var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class PanasonicCamera {
    constructor(log) {
        this.power = false;
        this.firmwareVersion = 'V01.07L000';
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23QSV1&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `qSV1${this.firmwareVersion}`);
                }),
            },
            {
                name: 'powerQuerySet',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23O(0|1)?&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1])
                        this.power = match[1] === '1';
                    return this.makeResponse(req, `p${this.power ? '1' : '0'}`);
                }),
            },
            {
                name: 'cameraPanTiltZoomSet',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23([PTZ])(\d{2})&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `${match[1].toLowerCase()}S${match[2]}`);
                }),
            },
            {
                name: 'cameraPanTiltStop',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23PTS5050&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `pTS5050`);
                }),
            },
            {
                name: 'panTiltPositionQuerySet',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23APC([0-9a-f]{8})?&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    return this.makeResponse(req, `aPC${(_a = match[1]) !== null && _a !== void 0 ? _a : '9B5783FE'}`);
                }),
            },
            {
                name: 'ZoomQuery',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23GZ&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `gz55B`);
                }),
            },
            {
                name: 'ZoomSet',
                path: /\/cgi-bin\/aw_ptz\?cmd=%23AXZ([0-9a-f]{3})&res=1/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `aXZ${match[1]}`);
                }),
            },
            {
                name: 'invalid',
                path: /(\/cgi-bin\/aw_ptz\?cmd=%23)?(.+)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, `eR01:${match[1]}`);
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            // need URL field?
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${result.length}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'text/plain',
            },
            data: result,
        };
    }
}
PanasonicCamera.emulatorType = 'httpRequestEmulator';
PanasonicCamera.key = '-NFoChVNR7sv1lO2CyIn';
